/**
 * Сводка «за неделю»: оформление того, что присылает сервер
 * (GET /api/dashboard/week).
 */
import { plural } from './plural';

const pad = (n) => String(n).padStart(2, '0');

/** «только что», «25 мин назад», «3 ч назад», «вчера», «4 дня назад» */
export function agoText(at, now = Date.now()) {
  const min = Math.floor((now - at) / 60000);
  if (min < 2) return 'только что';
  if (min < 60) return `${min} мин назад`;
  const hours = Math.floor(min / 60);
  if (hours < 24) return `${hours} ч назад`;
  const days = Math.floor(hours / 24);
  if (days === 1) return 'вчера';
  return `${days} ${plural(days, 'день', 'дня', 'дней')} назад`;
}

/** «03.11» */
export const shortDate = (ms) => {
  const d = new Date(ms);
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}`;
};

/**
 * Учёт изменений начался недавно — неделя ещё не набралась.
 * Возвращает подпись или null.
 */
export function trackingNote(summary) {
  if (!summary || !summary.trackingSince || summary.trackingSince <= summary.since) return null;
  const full = summary.trackingSince + summary.days * 24 * 60 * 60 * 1000;
  return `Изменения считаются с ${shortDate(summary.trackingSince)} — полная неделя наберётся к ${shortDate(full)}.`;
}
